import { ToolbarAnchor } from '@components/ArtBoard/ArtboardToolbar'
import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'
import type { ExternalLink } from '@octopus-do/octopus-project-core'
import { Toolbar } from '@octopus-do/octopus-storybook'
import { Clone, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { createSwitch } from '@/utils'
import { EDIT_LINK_POPOVER_ID, EditLinkPopover } from './components'
import { LINK_BORDER_WIDTH } from './constants'
import { useExternalLinkActions } from './hooks'

interface Props {
  link: ExternalLink
}

export const ExternalLinkActionsToolbar: React.FC<Props> = ({ link }) => {
  const { onDelete, onDuplicate, onEditUrl } = useExternalLinkActions(link)

  const { scale } = getCanvasState(
    document.getElementById('gestureMovableContainer')
  )

  const switcher = createSwitch()
    .case([EDIT_LINK_POPOVER_ID], onEditUrl)
    .case(['duplicate'], onDuplicate)
    .case(['delete'], onDelete)

  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <ToolbarAnchor borderWidth={LINK_BORDER_WIDTH} scale={scale}>
      <Toolbar.Root onClick={onClick}>
        <EditLinkPopover url={link.data.url} />
        <Toolbar.Divider />
        <Toolbar.Button icon={Clone} id="duplicate" tooltip="Duplicate" />
        <Toolbar.Button
          icon={Trash}
          id="delete"
          tooltip="Delete"
          variant="danger"
        />
      </Toolbar.Root>
    </ToolbarAnchor>
  )
}
